import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import validator from 'validator';

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    fullWidth: true,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  warningButton: {
    margin: theme.spacing.unit,
    color: "white",
    backgroundColor: "#E9190F",
    '&:hover': {
      backgroundColor: "#E9190F",
    },
  }
});

class Profile extends Component {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
    this.handlePasswordInputChange = this.handlePasswordInputChange.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleVerifyInputChange = this.handleVerifyInputChange.bind(this);
    this.handleVerifyEmailAddress = this.handleVerifyEmailAddress.bind(this);
    this.handleRequestVerificationCode =  this.handleRequestVerificationCode.bind(this);
    this.state = {
      deleteProfileModalOpen: false,
      deleteConfirmation: ""
    }
  }

  handlePasswordInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.props.profileStore.passwords[name] = value;

    if (this.props.profileStore.passwords.newPassword !== null && this.props.profileStore.passwords.newPasswordConfirmation !== null) {
      if (this.props.profileStore.passwords.newPassword !== "" && this.props.profileStore.passwords.newPasswordConfirmation !== "") {
        if (this.props.profileStore.passwords.newPassword === this.props.profileStore.passwords.newPasswordConfirmation) {
          this.props.profileStore.passwords.confirmed = true;
        } else {
          this.props.profileStore.passwords.confirmed = false;
        }
      } else {
        this.props.profileStore.passwords.confirmed = false;
      }
    } else {
      this.props.profileStore.passwords.confirmed = false;
    }
  }

  handleEmailInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.props.profileStore.mail[name] = value;

    if (this.props.profileStore.mail.newEmailAddress !== null && this.props.profileStore.mail.newEmailAddressConfirmation !== null) {
      if (this.props.profileStore.mail.newEmailAddress !== "" && this.props.profileStore.mail.newEmailAddressConfirmation !== "") {
        if (this.props.profileStore.mail.newEmailAddress === this.props.profileStore.mail.newEmailAddressConfirmation) {
          this.props.profileStore.mail.confirmed = true;
        } else {
          this.props.profileStore.mail.confirmed = false;
        }
      } else {
        this.props.profileStore.mail.confirmed = false;
      }
    } else {
      this.props.profileStore.mail.confirmed = false;
    }
  }

  handleVerifyInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.props.profileStore.mail[name] = value;
  }

  handleChangePassword() {
    this.props.profileStore.changePassword();
  }

  handleChangeEmail() {
    this.props.profileStore.changeEmailAddress();
  }

  handleRequestVerificationCode() {
    this.props.profileStore.requestVerificationCode();
  }

  handleVerifyEmailAddress() {
    this.props.profileStore.verifyEmailAddress();
  }

  handleDeleteProfile() {
    this.props.profileStore.deleteProfile();
  }

  componentDidMount() {
    this.props.profileStore.getUserDetails();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
          <Dialog
            open={this.state.deleteProfileModalOpen}
            onClose={() => this.setState({deleteProfileModalOpen: false})}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{"Benutzerkonto löschen?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Wenn Sie Ihr Konto, sowie sämtliche mit Ihrem Konto verknüpften Sticker wirklich löschen möchten, geben Sie bitte das Wort <strong>Löschen</strong> im folgenden Textfeld ein:
              </DialogContentText>
              <TextField
                id="deleteConfirmation"
                name="deleteConfirmation"
                label="Bestätigung"
                fullWidth={true}
                className={classes.textField}
                value={this.state.deleteConfirmation || ''}
                onChange={(event) => this.setState({deleteConfirmation: event.target.value})}
                margin="normal"
                InputLabelProps={{shrink: true}}
                type="text"
              />
              <DialogContentText id="alert-dialog-description">
                <span style={{color: 'red'}}>Dieser Schritt kann nicht rückgängig gemacht werden.</span>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({deleteProfileModalOpen: false})} color="primary">
                Abbrechen
              </Button>
              <Button onClick={() => this.handleDeleteProfile()} color="secondary" className={classes.warningButton} disabled={(this.state.deleteConfirmation.toLowerCase() !== "löschen")}>
                Löschen
              </Button>
            </DialogActions>
          </Dialog>
          <Grid container spacing={24}>
            <Grid item xs={12} lg={6}>
              <Typography variant="h6" gutterBottom>
                Benutzerkonto
              </Typography>
              <Grid container spacing={24}>
                <Grid item xs={12} lg={12}>   
                  <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="flex-end">
                    <Grid item xs={12} lg={12}>
                      <TextField
                        id="email"
                        name="email"
                        label="E-Mail Adresse / Benutzername"
                        className={classes.textField}
                        value={this.props.profileStore.user.email || ''}
                        margin="normal"
                        InputLabelProps={{shrink: true}}
                        fullWidth={true}
                        helperText={!this.props.profileStore.user.email_verified ? "Nicht verifiziert" : "Verifiziert"}
                        FormHelperTextProps={{ error: !this.props.profileStore.user.email_verified }}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </Grid>
            </Grid>
          </Grid>
        </Grid>
        {!this.props.profileStore.user.email_verified &&
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom style={{marginTop:"20px"}}>
                E-Mail Adresse verifizieren
            </Typography>
            Ihre E-Mail Adresse wurde geändert. Bitte bestätigen Sie die Änderung, in dem Sie den Bestätigungscode, der an Ihre neue E-Mail Adresse geschickt wurde, eingeben.
            <TextField
              id="verificationCode"
              name="verificationCode"
              label="Bestätigungscode"
              fullWidth={true}
              className={classes.textField}
              value={this.props.profileStore.mail.verificationCode || ''}
              onChange={this.handleVerifyInputChange}
              margin="normal"
              InputLabelProps={{shrink: true}}
              type="number"
            />
            <Button variant="contained" color="secondary" fullWidth className={classes.button} onClick={this.handleVerifyEmailAddress}>
              E-Mail Adresse bestätigen
            </Button>
            <Button variant="contained" color="primary" fullWidth className={classes.button} onClick={this.handleRequestVerificationCode}>
              Neuen Code anfordern
            </Button>
          </Grid>
        </Grid>
        }
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom style={{marginTop:"20px"}}>
                E-Mail Adresse ändern
            </Typography>
              <TextField
                id="newEmailAddress"
                name="newEmailAddress"
                label="Neue E-Mail Adresse"
                fullWidth={true}
                className={classes.textField}
                value={this.props.profileStore.mail.newEmailAddress || ''}
                onChange={this.handleEmailInputChange}
                margin="normal"
                InputLabelProps={{shrink: true}}
                type="email"
                helperText={this.props.profileStore.mail.newEmailAddress ? (!validator.isEmail(this.props.profileStore.mail.newEmailAddress) ? "Bitte geben Sie eine gültige E-Mail Adresse ein" : null) : false}
                error={this.props.profileStore.mail.newEmailAddress ? !validator.isEmail(this.props.profileStore.mail.newEmailAddress) : false}

              />
              <TextField
                id="newEmailAddressConfirmation"
                name="newEmailAddressConfirmation"
                label="Neue E-Mail Adresse wiederholen"
                fullWidth={true}
                className={classes.textField}
                value={this.props.profileStore.mail.newEmailAddressConfirmation || ''}
                onChange={this.handleEmailInputChange}
                margin="normal"
                InputLabelProps={{shrink: true}}
                type="email"
                helperText={this.props.profileStore.mail.newEmailAddressConfirmation ? (!validator.isEmail(this.props.profileStore.mail.newEmailAddressConfirmation) ? "Bitte geben Sie eine gültige E-Mail Adresse ein" : null) : false}
                error={this.props.profileStore.mail.newEmailAddressConfirmation ? !validator.isEmail(this.props.profileStore.mail.newEmailAddressConfirmation) : false}
              />            
            <Button variant="contained" color="secondary" fullWidth className={classes.button} onClick={this.handleChangeEmail} disabled={!this.props.profileStore.mail.confirmed}>
              E-Mail Adresse ändern
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom style={{marginTop:"20px"}}>
                Kennwort ändern
            </Typography>
            <TextField
              id="oldPassword"
              name="oldPassword"
              label="Aktuelles Kennwort"
              fullWidth={true}
              className={classes.textField}
              value={this.props.profileStore.passwords.oldPassword || ''}
              onChange={this.handlePasswordInputChange}
              margin="normal"
              InputLabelProps={{shrink: true}}
              type="password"
              autoComplete="current-password"
            />
            <TextField
              id="newPassword"
              name="newPassword"
              label="Neues Kennwort"
              fullWidth={true}
              className={classes.textField}
              value={this.props.profileStore.passwords.newPassword || ''}
              onChange={this.handlePasswordInputChange}
              margin="normal"
              InputLabelProps={{shrink: true}}
              type="password"
              autoComplete="new-password"
            />
            <TextField
              id="newPasswordConfirmation"
              name="newPasswordConfirmation"
              label="Neues Kennwort wiederholen"
              fullWidth={true}
              className={classes.textField}
              value={this.props.profileStore.passwords.newPasswordConfirmation || ''}
              onChange={this.handlePasswordInputChange}
              margin="normal"
              InputLabelProps={{shrink: true}}
              type="password"
              autoComplete="new-password"
            />
            <Button variant="contained" color="secondary" fullWidth className={classes.button} onClick={this.handleChangePassword} disabled={!this.props.profileStore.passwords.confirmed}>
              Kennwort ändern
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom style={{marginTop:"20px"}}>
              Benutzerkonto löschen
            </Typography>
            Sie könnne Ihr Benutzerkonto jederzeit löschen. Bitte beachten Sie, dass mit der Löschung Ihres Kontos sämtliche Sticker, die Sie mit diesem Konto verknüpft haben, unbrauchbar werden.<br>
            </br>
            Die Löschung Ihres Kontos kann nicht rückgängig gemacht werden. Ihr Konto wird nicht archiviert. Ihr Konto wird umgehend gelöscht.
            <Button variant="contained" color="secondary" fullWidth className={classes.warningButton} onClick={() => this.setState({deleteProfileModalOpen: true})}>
              Benutzerkonto löschen
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(observer(Profile));